import * as React from 'react';

import { FormValue, FormError, FieldProps, FormValues } from 'informed';
import { SelectFieldModel, InputModel } from '..';

import classNames from 'classnames';
import * as validator  from 'validator';
import { RadioModel } from '.';
import { FormState } from 'informed';

// TODO Replace any
export function createFieldProps(field: InputModel, error: boolean, touched: boolean, id: string): FieldProps<any, any> & React.InputHTMLAttributes<HTMLInputElement> {
  const repeatInfo = splitValidation(field);
  const notify = repeatInfo && repeatInfo[0] ? [repeatInfo[0]] : undefined;
  return {
    autoComplete: field.autocomplete,
    className: classNames('form-control border-top-0 border-left-0 border-right-0 p-0', {'is-invalid': error}),
    field: field.name, 
    id: id,
    name: field.name,
    notify: notify,
    placeholder: field.placeholder,
    required: field.required,
    type: field.type,
    validateOnChange: field.required,
    validateOnBlur: field.required,
    validateOnMount: true,
  };
}

export function validateTextDefault(value: FormValue, field: InputModel): FormError {
  if (!field.validation || !validator[field.validation]) {
    return;
  }
  value = typeof value === 'undefined' ? '' : value;

  const isValid = value.toString().length > 0 && field.validation === 'isLength' ? 
    validator[field.validation](value.toString(), {min: field.minLength || 2}) : 
    validator[field.validation](value);
  return !isValid ? field.errorMessage && field.errorMessage.length > 0 ? field.errorMessage : 'Field Error' : undefined;
}

export function validatePassword(value: FormValue, field: InputModel): FormError {
  value = typeof value === 'undefined' ? '' : value;
  const password = value ? value[0].length > 1 ? value[0] : value ? value.toString() : '' : '';
  const stringLength = password.length >= 8;
  const countSpecialChars = (password.match(/[@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g) || []).length >= 1;
  const countDigits = (password.match(/\d/g) || []).length >= 1;
  const countUppercaseLetters = (password.match(/[A-Z]/g) || []).length >= 1;
  const specialCharsAndDigits = countSpecialChars && countDigits;
  const digitsAndUppercaseLetters = countDigits && countUppercaseLetters;
  const uppercaseLettersAndSpecialChars = countUppercaseLetters && countSpecialChars;
  const isValidPassword = value.toString().length > 0 && stringLength && (specialCharsAndDigits || digitsAndUppercaseLetters || uppercaseLettersAndSpecialChars);
  return !isValidPassword ? field.errorMessage && field.errorMessage.length > 0 ? field.errorMessage : 'Field Error' : undefined;
}


export function validateRepeat(value: FormValue, field: InputModel, compareableValue?: FormValue): FormError {
  value = typeof value === 'undefined' ? '' : value;
  return value.toString().length > 0 && value !== compareableValue ? field.errorMessage && field.errorMessage.length > 0 ? field.errorMessage : 'Field Error' : undefined;
}

export function splitValidation(field: InputModel): undefined | string[] {
  if (field.validation && field.validation.indexOf('.') > -1) {
    return field.validation.split('.');
  }
  return;
}

export function validateText<M>(value: FormValue, field: InputModel, values?: FormState<M>): FormError {

  const repeatInfo = splitValidation(field);

  // for comparing newPassword with it repeat at password change
  let key = 'newPassword';
  let newPassword = values && values[key] ? values[key] : undefined;

  const repeatValue = repeatInfo && values && values[repeatInfo[0]] ? values[repeatInfo[0]] : undefined;

  if (!value || value.toString().length < 1) {
    return;
  }

  if (field.required && field.validation) {
    switch (field.validation) {
      case 'email.Repeat':
        if (repeatValue) {
          return validateRepeat(value, field, repeatValue);
        }
        return;
      case 'password.Repeat':
        if (repeatValue && newPassword) {
          return validateRepeat(newPassword, field, repeatValue);
        } else if (repeatValue) {
          return validateRepeat(value, field, repeatValue);
        }
        return;
      case 'isPassword':
        return validatePassword(value, field);
      default:
        return validateTextDefault(value, field);
    }
  }
  return;
}

export function validateSelect (value: FormValue, field: SelectFieldModel): FormError {    
  const valuesToCompare: FormValue[] = [];
  field.options.map(option => option.value && option.value.toString().length > 0 && valuesToCompare.push(option.value as FormValue));
  value = typeof value === 'undefined' ? '' : value;
  const isValid = valuesToCompare.indexOf(value) > -1;
  return !isValid ? field.errorMessage && field.errorMessage.length > 0 ? field.errorMessage : 'Bitte wählen Sie eine Option.' : undefined;
}

export function validateRadioGroup(value: FormValue, field: RadioModel): FormError {
  const valuesToCompare: FormValue[] = [];
  field.options.map(option => valuesToCompare.push(option.value as FormValue));
  value = typeof value === 'undefined' ? '' : value;
  const isValid = valuesToCompare.indexOf(value) > -1;
  return !isValid ? field.errorMessage && field.errorMessage.length > 0 ? field.errorMessage : 'Bitte wählen Sie eine Option.' : undefined;
}

export function disableInputField(field: {[key: string]: any}): {[key: string]: any} {
  field.disabled = true;
  return field;
}

export function disableAllInputFields<I = {}>(fields: I): I {
  Object.keys(fields).map(key => disableInputField(fields[key]));
  return fields;
} 

export function formFieldsToFormValues<F = {}>(formData: F): FormValues {
  const keys = Object.keys(formData);
  const formValues = {};
  keys.map(key => formValues[key] = formData[key].value);
  return formValues;
}